import moment from 'moment'

export const toDate = (value, format = 'DD/MM/YYYY') => {
  if (!value) return ''
  return moment(value).format(format)
}
export const toPrice = (value, separator) => {
  separator = separator || ','
  value = parseFloat(value) || 0
  return String(value.toFixed(2)).replace('.', separator)
}
export const toPercent = (value) => {
  value = (parseFloat(value) || 0) * 100
  return String(value.toFixed(2)) + '%'
}
export const toTextarea = (value) => {
  if (!value) return undefined
  value = String(value)
  return value.replace(/\n/g, '<br>')
}
export const toPriceCurrency = (price = 0, currency) => {
  let result = []

  if (!price) {
    price = 0
  }

  if (typeof price === 'number') {
    price = price.toFixed(2)
    price = price.padStart(2, '0')
    result.push(price)
  }
  if (currency) {
    result.push(currency)
  }

  return result.join(' ')
}
export const uppercase = (val) => {
  return String(val).toUpperCase()
}
